import { Component, OnInit } from '@angular/core';
import { SearchParams } from '@apply4u/models/search/search-params';
import { SearchService } from '@apply4u/services/search/search.service';
import { DatePosted, Relevancy } from '@apply4u/shared/constant/constant';
import { ToLowerCase } from '@apply4u/shared/helpers/common/string-helpers';

@Component({
  selector: 'sort-search-item',
  templateUrl: './sort-search.component.html',
  styleUrls: ['./sort-search.component.css']
})
export class SortSearchComponent implements OnInit {
  SearchParam: SearchParams;

  constructor(private searchService: SearchService,) {
  }

  ngOnInit() {
    this.SearchParam = this.searchService.SearchParams;
  }


  SortByHandler(isSortyByDate: boolean = false) {
    let sortby = isSortyByDate ? DatePosted : Relevancy;

    if (ToLowerCase(sortby) != ToLowerCase(this.SearchParam.SortBy)) {
      this.searchService.SearchParams.IsCustomSort = true;
      this.searchService.SearchParams.SortBy = sortby;
      this.searchService.SearchParams.IsFilterSearch = true;
      this.searchService.SearchRedirection();
    }
  }


}
